import { inject, Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { IConversation, IConversationDetails } from '../domain/conversation';

@Injectable({ providedIn: 'root' })
export class ConversationService {
    private readonly _http = inject(HttpClient);

    public getRecent(searchQuery: string | null): Observable<IConversation[]> {
        let params = new HttpParams();
        if (searchQuery) {
            params = params.set('search', searchQuery);
        }
        return this._http.get<IConversation[]>('/api/conversations', { params });
    }

    public get(conversationId: string): Observable<IConversationDetails> {
        return this._http.get<IConversationDetails>(`/api/conversations/${conversationId}/messages`);
    }

    public delete(conversationId: string): Observable<any> {
        return this._http.post<any>(`/api/conversations/${conversationId}`, {});
    }
}
